import React from 'react';
import { observer } from 'mobx-react';

import { clientStore } from 'apps/client/app';
import {
  isInDesktopMode,
  switchToHomeTab,
} from 'libs/gutClient/electronBridge';
import { useDesktopCompatibility } from 'hooks/useDesktopCompatible';
import { routerStore } from 'core/routing';
import { DefaultMenuRoute } from 'constants/global';

import { Tooltip } from 'components';
import { staticURL } from 'core/url';

const FirstCrumbItemWrapper = ({
  children,
  onClick,
  dataTestId = 'back-to-home',
}: {
  children: React.ReactNode;
  onClick: () => void;
  dataTestId?: string;
}) => {
  return (
    <div
      data-testid={dataTestId}
      className='flex cursor-pointer border-r justify-center border-gray-200 items-center w-[40px] h-[32px]'
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export const BackButton = observer(() => {
  const compatibleWithTab = useDesktopCompatibility({
    feature: 'tab',
  });

  if (isInDesktopMode()) return null;

  const { navigate } = routerStore;

  const navigateToSpaceBoard = () => {
    if (isInDesktopMode() && compatibleWithTab) {
      switchToHomeTab();

      return;
    }

    navigate(DefaultMenuRoute, {
      spacePath: clientStore.slugFromRouteOrSpace,
    });
  };

  return (
    <FirstCrumbItemWrapper onClick={navigateToSpaceBoard}>
      <Tooltip delayShow={200} place='bottom' id='back' />
      <img
        width={8}
        height={8}
        data-for='back'
        data-tip='Back to workspace'
        className='select-none'
        src={staticURL('assets/icons/arrowLeft.svg')}
        alt='back'
        onDragStart={(event: any) => {
          // not allow to drag the arrow
          event.preventDefault();
        }}
      />
    </FirstCrumbItemWrapper>
  );
});
